export { ContextoDaBarraSuperior } from './barra-superior.context'
export * from './barra-superior.interface'
